import script from "./CalculateSp2.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculateSp2.vue?vue&type=script&setup=true&lang=js"

import "./CalculateSp2.vue?vue&type=style&index=0&id=7bdafdf3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdafdf3"]])

export default __exports__